const t=":host{display:flex;width:fit-content;height:fit-content}:host>* ::slotted(*){--md-icon-size: var(--_icon-size);font-weight:inherit}:host cds-icon{--cds-icon-color: var(--_icon-color)}";export{t as default};
